/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
class Collection {
	constructor() {
		this.currencySymbol = "£";
		this.init();
	}

	// eslint-disable-next-line class-methods-use-this
	redirectSort(newSort) {
		const url = new URL(window.location.href);
		const { pathname, search } = url;
		const currentSort = pathname.split("/")[3];

		if (currentSort === newSort) return;

		let newLocation;

		if (currentSort) {
			const newPath = pathname.replace(currentSort, newSort).replace("//", "/");
			newLocation = new URL(`${url.origin}${newPath}${search}`);
		} else {
			const delimiter = pathname.charAt(pathname.length - 1) === "/" ? "" : "/";
			newLocation = new URL(`${url.origin}${pathname}${delimiter}${newSort}/${search}`);
		}

		window.location.href = newLocation;
	}

	handleReset() {
		this.filterResetBtns.forEach((resetBtn) => {
			resetBtn.addEventListener("click", () => {
				this.filterGroups.forEach((filterGroup) => {
					const filterValues = Array.from(filterGroup.querySelectorAll("[data-filter-value]"));
					filterValues.forEach((filterValue) => {
						filterValue.checked = false;
					});
					filterGroup.removeAttribute("data-filter-active");
				});
				this.filtersChanged({ shouldScroll: true });
			});
		});
	}

	filtersChanged({ shouldScroll = false } = {}) {
		this.updateMobileActiveIcon();
		this.updateProductList();
		this.updateUrl();
		this.updateProductNumber();
		this.checkedInGroup();
		this.updateFilters();
		this.createFilterSummary();
		// this.setFiltersFromUrl()

		if (shouldScroll) {
			const target = document.querySelector(".main-grid");
			if (target) {
			  const extraSpace = 150;
			  const y = target.getBoundingClientRect().top + window.scrollY - extraSpace;
			  window.scrollTo({ top: y, behavior: "smooth" });
			}
		}
	}

	createFilterSummary() {
		const mobileSummary = this.rootElement.querySelector("[data-mobile-selected-filters]");
		const desktopSummary = this.rootElement.querySelector("[data-desktop-selected-filters]");
		const totalActiveFilters = Object.values(this.activeFilters).reduce((sum, arr) => sum + arr.length, 0);

		if (totalActiveFilters > 0) {
			mobileSummary.textContent = totalActiveFilters;
			mobileSummary.classList.remove("hidden");
			desktopSummary.textContent = totalActiveFilters;
			desktopSummary.classList.remove("md:hidden");
		} else {
			mobileSummary.classList.add("hidden");
			desktopSummary.classList.add("md:hidden");
		}
	}

	parsePriceRange(filterValue) {
		const priceRange = { minimum: undefined, maximum: undefined };
		if (filterValue.startsWith("Up to")) {
			priceRange.minimum = 0;
			priceRange.maximum = +filterValue.split(this.currencySymbol)[1];
		} else if (filterValue.startsWith("Over")) {
			priceRange.minimum = +filterValue.split(this.currencySymbol)[1];
			priceRange.maximum = Infinity;
		} else {
			const [minPrice, maxPrice] = filterValue.split(" to ");

			priceRange.minimum = +minPrice.split("£")[1];
			priceRange.maximum = +maxPrice.split("£")[1];
		}
		return priceRange;
	}

	updateFilters() {
		this.filterGroups.forEach((group) => {
			const filterGroupKey = group.dataset.filterGroup;
			const values = Array.from(group.querySelectorAll("li"));
			values.forEach((value) => {
				const inputElement = value.querySelector("[data-filter-value]");
				const valueName = inputElement.dataset.filterValue; // eg. indoor
				const productCountElement = value.querySelector("[data-filter-value-count]"); // num items
				const productCount = this.filteredProducts.reduce((prev, curr) => {
					const productFilters = JSON.parse(curr.dataset.filters);
					if (productFilters[filterGroupKey] && productFilters[filterGroupKey].includes(valueName)) {
						return prev + 1;
					}

					if (filterGroupKey === "price") {
						const priceAsNumber = Number(productFilters[filterGroupKey]);
						const priceRange = this.parsePriceRange(valueName);
						if (priceAsNumber >= priceRange.minimum && priceAsNumber < priceRange.maximum) {
							return prev + 1;
						}
						return prev;
					}

					return prev;
				}, 0);

				productCountElement.innerText = productCount;
				value.toggleAttribute("hidden", productCount === 0);
			});
			const nonHiddenValues = values.some((value) => value.getAttribute("hidden") === null);
			group.toggleAttribute("hidden", !nonHiddenValues);
		});
	}

	updateProductNumber() {
		const count = this.productNumber;
		this.productNumberDisplay.forEach((ele) => {
			ele.innerText = count;
		});

		const productLabel = this.rootElement.querySelectorAll("[data-product-label]");
		productLabel.forEach((ele) => {
			ele.innerText = count === 1 ? " item" : " items";
		});
	}

	updateMobileActiveIcon() {
		this.mobileFilterActive.toggleAttribute("hidden", Object.keys(this.activeFilters).length === 0);
	}

	checkedInGroup(filterGroup, filterValues) {
		if (filterGroup) {
			const values = filterValues || Array.from(filterGroup.querySelectorAll("[data-filter-value]"));
			const checkedInGroup = values.some((input) => input.checked);
			filterGroup.toggleAttribute("data-filter-active", checkedInGroup);
		} else {
			this.filterGroups.forEach((group) => {
				this.checkedInGroup(group);
			});
		}
	}

	handleFilters() {
		const span = this.desktopFilterToggle?.querySelector("span");
		if (!span) return;
		this.desktopFilterToggle.addEventListener("click", () => {
			const getProductCols = parseInt(localStorage.getItem("desktopGrid") || "3", 10);
			const mainCols = getProductCols + 1;
			const isExpanded = this.filterElement.getAttribute("aria-expanded") === "true";
			const willOpen = !isExpanded;

			localStorage.setItem("filterOpen", willOpen ? "1" : "0");

			if (span.textContent.trim() === "Sort & filter") {
				span.textContent = "Hide";
				this.mainGrid.classList.remove("md:grid-cols-3", "md:grid-cols-4", "md:grid-cols-5");
				this.mainGrid.classList.add(`md:grid-cols-${mainCols}`);
			} else {
				span.textContent = "Sort & filter";
				this.mainGrid.classList.remove("md:grid-cols-3", "md:grid-cols-4", "md:grid-cols-5");
				this.mainGrid.classList.add(`md:grid-cols-${getProductCols}`);
			}

			this.filterElement.setAttribute("aria-expanded", String(willOpen));
			this.filterElement.classList.toggle("hidden", !willOpen);
		});

		this.mobileFilterToggles.forEach((toggle) => {
			toggle.addEventListener("click", () => {
				const isExpanded = this.mobileFilter.getAttribute("aria-expanded") === "true";
				this.mobileFilter.setAttribute("aria-expanded", `${!isExpanded}`);
				this.mobileFilter.classList.toggle("invisible", isExpanded);

				document.documentElement.classList.toggle("overflow-hidden", !isExpanded);
			});
		});

		const sortToggleButton = this.sortGroups.querySelector("[data-sort-group-toggle]");
		const sortMobileToggleButton = this.mobileSortGroups.querySelector("[data-mobile-sort-group-toggle]");
		if (sortToggleButton && sortMobileToggleButton) {
			sortToggleButton.addEventListener("click", () => {
				this.sortGroups.toggleAttribute("open");
			});

			sortMobileToggleButton.addEventListener("click", () => {
				this.mobileSortGroups.toggleAttribute("open");
			});
		}

		this.filterGroups.forEach((filterGroup) => {
			const filterToggleButton = filterGroup.querySelector("[data-filter-group-toggle]");
			filterToggleButton.addEventListener("click", () => filterGroup.toggleAttribute("open"));

			const filterValues = Array.from(filterGroup.querySelectorAll("[data-filter-value]"));
			filterValues.forEach((filterValue) => {
				filterValue.addEventListener("change", ({ target }) => {
					const filterPair = this.rootElement.querySelectorAll(`[data-filter-value="${target.dataset.filterValue}"]`);
					filterPair.forEach((filter) => {
						filter.checked = target.checked;
					});
					this.checkedInGroup(filterGroup, filterValues);
					this.filtersChanged({ shouldScroll: true });
				});
			});
		});
	}

	get activeFilters() {
		return this.filterGroups.reduce((prev, curr) => {
			const activeFiltersInGroup = Array.from(curr.querySelectorAll("[data-filter-value]"))
				.filter((filterValue) => filterValue.checked)
				.map((filterValue) => filterValue.dataset.filterValue);

			if (activeFiltersInGroup.length === 0) return prev;

			return { ...prev, [curr.dataset.filterGroup]: activeFiltersInGroup };
		}, {});
	}

	get productNumber() {
		return this.filteredProducts.length;
	}

	updateProductList() {
		this.filteredProducts.forEach((product) => product.setAttribute("hidden", "hidden"));
		this.filteredProducts = this.allProducts.filter((product) =>
			Object.entries(this.activeFilters).every(([group, value]) => {
				const productFilters = JSON.parse(product.dataset.filters); // {}
				if (!productFilters[group]) return false;

				if (group === "price") {
					const priceRange = this.parsePriceRange(value[0]);
					const priceAsNumber = Number(productFilters[group]);
					return priceAsNumber >= priceRange.minimum && priceAsNumber < priceRange.maximum;
				}

				return productFilters[group].find((v) => value.includes(v)) || false;
			})
		);

		this.filteredProducts.forEach((product) => product.removeAttribute("hidden"));
	}

	handleSortToggle() {
		if (!this.sortOptions || this.sortOptions.length === 0) return;

		this.sortOptions.forEach((opt) => {
			opt.addEventListener("change", ({ currentTarget }) => {
				const slug = currentTarget.dataset.sortOption || "";
				this.redirectSort(slug);
			});
		});
	}

	getSortOption() {
		if (!this.sortOptions || this.sortOptions.length === 0) return;

		const SLUGS = ["", "best-selling", "price-descending", "price-ascending", "created-descending"];
		const parts = window.location.pathname.split("/").filter(Boolean);
		const active = parts.find((p) => SLUGS.includes(p)) || "";

		this.sortOptions.forEach((input) => {
			input.checked = input.dataset.sortOption === active;
		});
	}

	setFiltersFromUrl() {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);
		Array.from(searchParams.entries()).forEach(([activeGroup, activeValue]) => {
			const filterGroup = this.filterGroups.filter((group) => group.dataset.filterGroup === activeGroup);
			if (filterGroup.length === 0) return;
			filterGroup.forEach((group) => {
				const filterValue = Array.from(group.querySelectorAll("[data-filter-value]")).find(
					(value) => value.dataset.filterValue === activeValue
				);
				if (!filterValue) return;
				filterValue.checked = true;
			});
		});
	}

	updateUrl() {
		const url = new URL(window.location.href);
		this.filterGroups.forEach((group) => {
			url.searchParams.delete(group.dataset.filterGroup);
		});
		Object.entries(this.activeFilters).forEach(([key, values]) => {
			values.forEach((value) => {
				url.searchParams.append(key, value);
			});
		});
		window.history.replaceState(null, null, url);
	}

	handleSubheader() {
		if (this.readMoreToggles.length === 0) return;
		this.readMoreToggles.forEach((toggle) => {
			toggle.addEventListener("click", () => {
				const readMoreTarget = toggle.dataset.readMoreToggle;
				if (!readMoreTarget) return;
				const readMoreTargetElement = document.querySelector(`#${readMoreTarget}`);
				if (!readMoreTargetElement) return;
				this.readMoreToggles.forEach((otherToggle) => {
					otherToggle.removeAttribute("hidden");
				});
				toggle.setAttribute("hidden", "hidden");
				readMoreTargetElement.toggleAttribute("hidden");
			});
		});
	}

	productGridToggle() {
		const productGrid = document.querySelector(".product-grid");
		const collectionItemsList = document.querySelector(".collection-items-list");

		document.querySelectorAll(".grid-toggle").forEach((icon) => {
			icon.addEventListener("click", (event) => {
				event.stopPropagation();

				const cols = icon.classList.contains("toggle-3") ? 3 : 4;

				productGrid.classList.remove("md:grid-cols-3", "md:grid-cols-4");
				productGrid.classList.add(`md:grid-cols-${cols}`);
				collectionItemsList.classList.remove("md:col-span-3", "md:col-span-4");
				collectionItemsList.classList.add(`md:col-span-${cols}`);

				const filterOpen = this.filterElement.getAttribute("aria-expanded") === "true";
				this.mainGrid.classList.remove("md:grid-cols-3", "md:grid-cols-4", "md:grid-cols-5");
				this.mainGrid.classList.add(`md:grid-cols-${cols + (filterOpen ? 1 : 0)}`);

				localStorage.setItem("desktopGrid", cols);
				this.highlightDesktopToggle(cols);
			});
		});

		document.querySelectorAll(".mobile-grid-toggle").forEach((icon) => {
			icon.addEventListener("click", (event) => {
				event.stopPropagation();

				const cols = icon.classList.contains("toggle-1") ? "1" : "2";

				this.mainGrid.classList.remove("grid-cols-1", "grid-cols-2");
				this.mainGrid.classList.add(`grid-cols-${cols}`);
				productGrid.classList.remove("grid-cols-1", "grid-cols-2");
				productGrid.classList.add(`grid-cols-${cols}`);

				localStorage.setItem("mobileGrid", cols);
				this.highlightMobileToggle(cols);
			});
		});
	}

	highlightDesktopToggle(cols) {
		document.querySelectorAll(".grid-toggle").forEach((el) => el.classList.remove("text-primary"));

		const saved = document.querySelector(`.grid-toggle.toggle-${cols}`);
		if (saved) saved.classList.add("text-primary");
	}

	highlightMobileToggle(cols) {
		document.querySelectorAll(".mobile-grid-toggle").forEach((el) => el.classList.remove("text-primary"));

		const saved = document.querySelector(`.mobile-grid-toggle.toggle-${cols}`);
		if (saved) saved.classList.add("text-primary");
	}

	applyGridLayout() {
		setTimeout(() => {
			this.rootElement.classList.remove("opacity-0");
		}, 50);

		const productGrid = document.querySelector(".product-grid");
		const savedDesktopGrid = parseInt(localStorage.getItem("desktopGrid") || "3", 10);
		const savedMobileGrid = parseInt(localStorage.getItem("mobileGrid") || "2", 10);
		const collectionItemsList = document.querySelector(".collection-items-list");
		const savedFilterOpen = localStorage.getItem("filterOpen") === "1";

		const mainCols = savedDesktopGrid + (savedFilterOpen ? 1 : 0);

		this.filterElement.setAttribute("aria-expanded", String(savedFilterOpen));
		this.filterElement.classList.toggle("hidden", !savedFilterOpen);

		// Mobile
		this.mainGrid.classList.remove("grid-cols-1", "grid-cols-2");
		productGrid.classList.remove("grid-cols-1", "grid-cols-2");
		this.mainGrid.classList.add(`grid-cols-${savedMobileGrid}`);
		productGrid.classList.add(`grid-cols-${savedMobileGrid}`);

		// Desktop
		this.mainGrid.classList.remove("md:grid-cols-3", "md:grid-cols-4", "md:grid-cols-5");
		productGrid.classList.remove("md:grid-cols-3", "md:grid-cols-4");
		collectionItemsList.classList.remove("md:col-span-3", "md:col-span-4");

		this.mainGrid.classList.add(`md:grid-cols-${mainCols}`);
		productGrid.classList.add(`md:grid-cols-${savedDesktopGrid}`);
		collectionItemsList.classList.add(`md:col-span-${savedDesktopGrid}`);

		this.highlightDesktopToggle(savedDesktopGrid);
		this.highlightMobileToggle(savedMobileGrid);

		const span = this.desktopFilterToggle?.querySelector("span");
		if (span) span.textContent = savedFilterOpen ? "Hide" : "Sort & filter";
	}

	attachStickyFilterBarObserver() {
		const bar = this.rootElement.querySelector("[data-filter-bar]");
		const sentinel = this.rootElement.querySelector("[data-filter-bar-sentinel]");
		if (!bar || !sentinel) return;

		const io = new IntersectionObserver(
			([entry]) => {
				bar.classList.toggle("is-stuck", !entry.isIntersecting);
			},
			{ threshold: 0, rootMargin: "0px 0px -1px 0px" }
		); // avoids top-edge jitter

		io.observe(sentinel);
	}

	init() {
		this.rootElement = document.querySelector("[data-collection]");
		this.mainGrid = document.querySelector(".main-grid");
		// Filtering
		this.filterElement = this.rootElement.querySelector("[data-collection-filter]");
		this.desktopFilterToggle = this.rootElement.querySelector("[data-filter-toggle]");
		this.filterResetBtns = Array.from(this.rootElement.querySelectorAll("[data-reset]"));
		this.filterGroups = Array.from(this.rootElement.querySelectorAll("[data-filter-group]"));
		this.mobileFilter = this.rootElement.querySelector("[data-collection-filter-mobile]");
		this.mobileFilterToggles = this.rootElement.querySelectorAll("[data-mobile-filter-toggle]");
		this.mobileFilterActive = this.rootElement.querySelector("[data-mobile-filter-active]");
		this.productNumberDisplay = Array.from(this.rootElement.querySelectorAll("[data-product-number]"));
		// Sorting
		this.sortGroups = this.filterElement.querySelector("[data-sort-group]");
		this.mobileSortGroups = this.mobileFilter.querySelector("[data-mobile-sort-group]");
		this.sortToggle = this.rootElement.querySelector("[data-sort-toggle]");
		this.mobileSortToggle = this.rootElement.querySelector("[data-mobile-sort-toggle]");
		this.mobileSortActive = this.rootElement.querySelector("[data-mobile-sort-active]");
		this.sortOptions = Array.from(this.rootElement.querySelectorAll("input[data-sort-option]"));

		this.allProducts = Array.from(this.rootElement.querySelectorAll("article[data-card]"));
		this.filteredProducts = [...this.allProducts];

		this.readMoreToggles = document.querySelectorAll("[data-read-more-toggle]");

		this.applyGridLayout();

		// Setting data to correct values from url & search params
		this.getSortOption();
		this.setFiltersFromUrl();

		// Updating DOM based on filters
		this.filtersChanged();

		// Adding event listeners
		this.handleFilters();
		this.handleReset();
		this.handleSortToggle();
		this.handleSubheader();
		this.productGridToggle();
		this.attachStickyFilterBarObserver();
	}
}

// eslint-disable-next-line no-new
window.patchCollection = new Collection();
